module.exports = __webpack_public_path__ + "static/media/sla_guideline_wework.ad16702e.jpeg";